export const PRODUCT_MAP = {
  '101': '智推宝',
  '125': '智推宝Lite',
  '230': '一点通-本地',
  '234': '一点通-全国'
}

export const PROMOTE_STATUS = {
  '0': '未投放',
  '1': '投放中',
  '2': '今日已达标'
}

export const PATH_ZTB = '/localMerchant/zhiTuiBao'
export const PATH_ZTB_INTRO = '/localMerchant/zhiTuiBao/introduce'
export const PATH_ZTB_BUY = '/localMerchant/zhiTuiBao/buy'
export const PATH_ZTB_ORDER = '/localMerchant/zhiTuiBao/order'
export const PATH_ZTB_DETAIL = '/localMerchant/zhiTuiBao/detail'

export const GET_EXTRA_NUMBER = 3

// 1上移，2下移，3置顶
export const ORDER_UP = 1
export const ORDER_DOWN = 2
export const ORDER_TOP = 3

export const TIAN_GONG_ZTB = 42
